// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PuE8","fullView":"styles_fullView__2MszQ"};